import { render, staticRenderFns } from "./AutoCompleteBox.vue?vue&type=template&id=53d3e7bb&"
import script from "./AutoCompleteBox.vue?vue&type=script&lang=js&"
export * from "./AutoCompleteBox.vue?vue&type=script&lang=js&"
import style0 from "./AutoCompleteBox.vue?vue&type=style&index=0&id=53d3e7bb&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports